import { EvtHeader } from "components/header";
import React from "react";
import CategoryForm from "../form";

const CreateCategory = () => {
  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Create Category" />
      <div className="p-6 max-w-2xl">
        <CategoryForm />
      </div>
    </div>
  );
};

export default CreateCategory;
